import { useRef, useEffect } from 'react';
import { NOOP } from '../../utils/const.js';

/**
 * Gestisce il contesto delle modali passando lo stato di show.
 */
function useModalContextImpl(context, ModalContext, open = false, options, callback) {
    const { setOpen, subscribe, unsubscribe } = context;
    const refLastState = useRef(false);
    useEffect(() => {
        if (callback)
            ModalContext.subscribeOrGlobal(subscribe, callback);
        return () => {
            if (callback)
                ModalContext.unsubscribeOrGlobal(unsubscribe, callback);
        };
    }, [callback, subscribe, unsubscribe, ModalContext]);
    useEffect(() => {
        if (refLastState.current === open)
            return NOOP;
        ModalContext.setOpenOrGlobal(open, setOpen, options);
        refLastState.current = open;
        return () => {
            if (open)
                ModalContext.setOpenOrGlobal(false, setOpen, options);
        };
    }, [open, setOpen, options, ModalContext]);
}

export { useModalContextImpl as default };
